import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Layer} from '../../../libs/shared/ui/src/components/layers/layer';
import {BrowserLink} from '../../../libs/shared/ui/src/components/links/browserLink';
import {EducationTipChrome} from '../../../libs/shared/ui/src/components/tip/educationTipChrome';
import {InfoBubbleCloseButton} from '../../../libs/shared/ui/src/components/tip/infoBubbleCloseButton';
import {InfoBubbleContent} from '../../../libs/shared/ui/src/components/tip/infoBubbleContent';
import {InfoBubbleDescription} from '../../../libs/shared/ui/src/components/tip/infoBubbleContentDescription';

/*
 * Props.
 */

interface PolicyViolationWarningTipProps {
  onDismiss: () => void;
}

/*
 * Style.
 */

// TODO: Standardize.
const StyledEducationTipChrome = styled(EducationTipChrome)`
  position: absolute;
  right: 16px;
  bottom: 16px;
`;

// TODO: Standardize.
const StyledParagraph = styled.p`
  margin: 0;

  & + & {
    margin-top: 1em;
  }
`;

/*
 * Component.
 */

export const PolicyViolationWarningTip: FC<PolicyViolationWarningTipProps> = (props) => (
  <Layer>
    <StyledEducationTipChrome>
      <InfoBubbleContent>
        <InfoBubbleDescription>
          <Trans id="policy-violation-warning-description">
            <StyledParagraph>
              Your Front account has been identified as violating the{' '}
              <BrowserLink url="https://help.front.com/en/articles/2374">
                End User Conduct and Content Policy
              </BrowserLink>{' '}
              incorporated in Front&apos;s SaaS Agreement. We have seen a large amount of suspicious email
              messages originating from your account and have blocked all outgoing messages from Front.
            </StyledParagraph>
            <StyledParagraph>
              You may not be able to reply to this message from the Front application. If so, please reply
              from a different system or address. This sending block will remain in place until we hear from
              you at support@front.com.
            </StyledParagraph>
          </Trans>
        </InfoBubbleDescription>
        <InfoBubbleCloseButton onClose={props.onDismiss} />
      </InfoBubbleContent>
    </StyledEducationTipChrome>
  </Layer>
);
